const _ = require('@sigma-legacy-libs/no-lodash')
const { SENDING_TYPES, SENDING_STATUS, SENDINGS_FALLBACKS_OPTIONS_CLEAN, SENDINGS_FALLBACKS_OPTIONS_DEFAULT } = require('../constants')

const statusFilter = status => ~SENDING_STATUS.indexOf(status)

class Fallbacks {
  static clean(fallbacks, options) {
    if (!Array.isArray(fallbacks)) {
      return []
    }

    if (!fallbacks.length) {
      return []
    }

    const { keepCommonId } = options || {}

    const result = []

    for (const fallback of fallbacks) {
      const { type, payload, commonId } = fallback || {}

      if (!~SENDING_TYPES.indexOf(type)) {
        continue
      }
      if (!payload || typeof payload !== 'object') {
        continue
      }
      if (!payload.sender && !payload.text) {
        continue
      }

      const cleanFallback = {
        type,
        payload,
        $options: Fallbacks.cleanOptions(fallback.$options || fallback.options)
      }

      if (commonId && keepCommonId) {
        cleanFallback.commonId = commonId
      }

      result.push(cleanFallback)
    }

    return result
  }

  static cleanOptions(options = SENDINGS_FALLBACKS_OPTIONS_CLEAN) {
    const result = {}

    for (const key in options) {
      let value = options[key]

      switch (key) {
        case 'onStatus': {
          if (Array.isArray(value) && value.length) {
            value = value.filter(statusFilter)
            result[key] = value
          }
          break
        }
        case 'onTimeout': {
          if (typeof value === 'object' && value) {
            const timeout = parseInt(value.timeout)
            const except = _.get(value, 'except', [])
            const filteredExcept = except.filter(statusFilter)
            if (Number.isInteger(timeout) && Array.isArray(filteredExcept) && filteredExcept.length) {
              result[key] = {
                timeout: timeout < 10 ? 10 : timeout,
                except: filteredExcept
              }
            }
          }
          break
        }
        case 'onIncomingPayload': {
          if (typeof value === 'object' && value && typeof value.text === 'string') {
            const text = ('' + value.text).trim()
            if (text) {
              result[key] = { text }
            }
          }
          break
        }
      }
    }

    return result
  }

  static applyOptionsDefaultsToFallbacks(fallbacks) {
    for (const fallback of fallbacks) {
      if (
        !fallback.$options ||
        typeof fallback.$options !== 'object' ||
        !Object.keys(fallback.$options).length
      ) {
        fallback.$options = SENDINGS_FALLBACKS_OPTIONS_DEFAULT
      }
    }

    return fallbacks
  }
}

module.exports = Fallbacks
